import React from "react";
import Founder from "@/components/Founder";
import Recommendations from "@/components/Recommendations";
import Legacy from "@/components/Legacy";

export default function FirmPage() {
  return (
    <div className="pt-24" data-testid="page-firm">
      <Founder />
      <Recommendations />
      <Legacy />
    </div>
  );
}
